<template>
    <div>
        <v-app class="p-4">
            <!--        <ads-selector></ads-selector>-->
            <div class="p-0 mt-5 pt-5" style="border: none!important;">
                <v-dialog
                        v-model="moreInfo"
                        max-width="600"
                        hide-overlay
                        transition="dialog-bottom-transition"
                >
                    <v-card>
                        <v-toolbar
                                flat
                                dark
                                color="primary"
                        >

                            <v-toolbar-title>انتخاب سایر ویژگی‌ها و امکانات</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-btn
                                        icon
                                        dark
                                        @click="moreInfo = false"
                                >
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-toolbar-items>
                        </v-toolbar>

                        <edit_other_attrs :fields="extraField"
                                          :param="schema.advertise.extra.other_options_and_attributes"></edit_other_attrs>
                    </v-card>
                </v-dialog>
                <categoryselector :editCategory="current" :edit="true" @category-schema="getSchema"
                                  @category-fields="getFields"
                                  ref="category"
                                  :multiAdsCat="false">
                </categoryselector>

                <div class="col-md-11 mx-auto">

                    <div class="col-md-8 mx-auto px-0">
                        <city-selector :defaultEdit="true" :editNeighbor="infos.neighborhood" :editCity="infos.city"
                                       ref="city"
                                       :force="true"></city-selector>
                    </div>
                    <div class="col-md-8 pt-0 mx-auto px-0">
                        <v-autocomplete outlined dense label="مشتریان" placeholder="نام مشتری مورد نظر را جستجو کنید."
                                        v-model="schema.advertise['customer_id']"
                                        clearable
                                        clear-icon="mdi-close-circle-outline"
                                        prepend-inner-icon="fa fa-pencil-alt"
                                        :items="customers" item-text="name" item-value="id"
                                        name="city">
                        </v-autocomplete>
                    </div>
                    <div class="col-md-8 pt-0 mx-auto px-0" v-if="Object.keys(infos).length > 0">
                        <image-uploader :for-new="true" :editImg="infos.extra.images"></image-uploader>
                    </div>
                </div>

                <div class="px-5 mx-1 pt-0">
                    <div v-if="extraField.length >0" class="col-md-8 px-0 mx-auto">
                        <v-btn @click="moreInfo = true" class="mr-6 font-weight-bold cursor-pointer text-white"
                               color="indigo">انتخاب سایر ویژگی‌ها و امکانات
                        </v-btn>
                    </div>
                    <input-maker :edit="true" ref="inputs" :editField="infos" :param="schema.advertise"
                                 :ui_schema="this.ui_schema"
                                 :fields="this.fields"></input-maker>
                </div>

                <div class="col-md-8 mr-auto">
                    <v-btn type="submit" class="submit-btn float-left" elevation="8" @click="updateAds">
                        <span class="fa fa-save pr-1" style="font-size: 1.3rem"></span>
                        بروزرسانی آگهی
                    </v-btn>
                </div>
            </div>
        </v-app>
    </div>
</template>

<script>
import TitleRibbon from "../../uiBeautifier/titleRibbon";
import Categoryselector from "../divarDependency/categorySelector";
import CitySelector from "../divarDependency/citySelector";
import inputMaker from "../divarDependency/inputMaker";
import {Axios2, Bus} from "../../../../main";
import ImageUploader from "../../uiBeautifier/imageUploader";
import Other_attrs from "../divarDependency/other_attrs";
import Edit_other_attrs from "../divarDependency/edit_other_attrs";
import NewCustomer from "../customer/newCustomer";
import CustomerList from "./estateList";

export default {
    name: "editArchive",
    components: {
        CustomerList,
        NewCustomer,
        Edit_other_attrs,
        Other_attrs,
        ImageUploader,
        CitySelector,
        Categoryselector,
        TitleRibbon,
        inputMaker
    },
    props: {
        ui_schema: {
            type: Array,
            default() {
                return []
            }
        },
        fields: {
            type: Array,
            default() {
                return [];
            }
        },
        edit: {
            type: Boolean,
            default: false,
        },
        editToken: {
            type: String,
            default: () => ""
        },
        modal: {
            default: false
        }
    },
    data() {
        return {
            current: '',
            category: '',
            customer_id: '',
            customers: [],
            moreInfo: false,
            schema: {
                advertise: {
                    category: "",
                    location: {
                        city: "",
                        neighborhood: ""
                    },
                    images: [],
                    contact: {
                        chat_enabled: '',
                        hide_phone: '',
                        phone: null
                    },
                    other_options_and_attributes: {}
                },
                available_at: '',
                expire_at: '',
            },
            EditToken: this.editToken,
            infos: [],
            extraField: []
        }
    },
    methods: {
        getSchema: function (value) {
            this.ui_schema = value;
        },
        getFields: function (val) {
            this.fields = val;
        },
        getadsData() {
            $.ajax({
                url: `${url}/user/archived/${this.editToken}`,
                type: 'GET',
                fn: this.getadsData,
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token
                },
                success: (data) => {
                    this.current = data.data.category;

                    this.category = {
                        slug: data.data.category
                    };
                    this.infos = data.data;
                    this.schema.advertise = data.data;
                }
            });
        },
        updateAds() {
            const data = {
                advertise: {
                    location: {
                        city: this.schema.advertise.city,
                        neighborhood: this.schema.advertise.neighborhood
                    },
                    images: this.schema.advertise.extra.images,
                    contact: {
                        chat_enabled: '',
                        hide_phone: '',
                        phone: null
                    },
                    other_options_and_attributes: this.schema.advertise.extra.other_options_and_attributes
                },
                customer_id: this.schema.advertise.customer_id
            };

            Object.keys(this.schema.advertise).filter(key => ["extra", "city","neighborhood", "customer", "user_id", "id", "customer_id", "created_at", "created_at_diff", "created_at_p", "deleted_at", "updated_at","updated_at_diff","updated_at_p","available_at","expire_at"].indexOf(key) === -1).forEach((x) => {
                data.advertise[x] = this.schema.advertise[x];
            });

            if (!this.$refs.inputs.validate() || !this.$refs.city.validate())
                return;

            if (data.available_at === "" || !data.available_at) {
                delete data.available_at;
            }

            if (data.expire_at === "" || !data.expire_at) {
                delete data.expire_at;
            }

            $.ajax({
                url: `${url}/user/archived/${this.editToken}`,
                method: 'PUT',
                fn: this.updateAds,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Token,
                    ACCEPT: 'application/json'
                },
                msg: true,
                data: JSON.stringify(data),
                success: () => {
                    this.modal();
                    this.infos = [];
                },
            })
        },
        getCustomers() {
            Axios2.get('/user/customer/all').then((res) => {
                this.customers = res.data.data
            })
        }
    },
    watch: {
        infos() {
            setTimeout(() => {
                Bus.$emit('getBreadCrumb', 10);
            }, 1000)
        },
        editToken() {
            this.getadsData()
        },
        moreInfo(value) {
            if (value) {
                Bus.$emit('getCurrent', this.current);
            }
        },

    },
    mounted() {
        Bus.$on('category-current', (value) => {
            this.schema.advertise.category = value;
            this.current = value
        });

        Bus.$on('cityInfo', (value) => {
            this.schema.advertise.location.city = value.city;
            if (value.neighborhood === '')
                delete this.schema.advertise.location.neighborhood;
            else
                this.schema.advertise.location.neighborhood = value.neighborhood;
        });

        Bus.$on('contact', (value) => {
            this.schema.advertise.contact.chat_enabled = value.chat_enabled;
            this.schema.advertise.contact.hide_phone = value.hide_phone;
            this.schema.auto_pay = value.autoPay;
        });

        Bus.$emit('editCategory', this.current);

        Bus.$on('selected_numbers', (value) => {
            this.schema.advertise.contact.phone = value
        });

        Bus.$on('selectedImage', (value) => {
            this.schema.advertise.images = value;
        });

        Bus.$on('parameters', (value) => {
            this.schema.advertise = value;
        });
        Bus.$on('other_attrs', (value) => {
            this.extraField = value;
        });

        this.getadsData();
        this.getCustomers();
    }

}
</script>

<style scoped>

</style>